<div class="app-shell">
  <div class="app-content">
    <router-outlet></router-outlet>
    <app-panoramer-global></app-panoramer-global>
  </div>
  <app-block-ui />
  @if ((tourGuideTooltipService.isTooltipEnabled$ | async) && !isMobile && isAdmin) {
    <app-tooltip-admin-toolbar></app-tooltip-admin-toolbar>
  }
</div>
